import { render } from "./RequestView.vue?vue&type=template&id=380216cf&ts=true"
import script from "./RequestView.vue?vue&type=script&lang=ts"
export * from "./RequestView.vue?vue&type=script&lang=ts"

import "./RequestView.vue?vue&type=style&index=0&id=380216cf&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__